import React from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon } from 'lucide-react';
const awards = [{
  title: 'Best Indian Restaurant 2023',
  organization: 'Thailand Culinary Awards'
}, {
  title: 'Excellence in Hospitality',
  organization: 'Asian Restaurant Association'
}, {
  title: 'Best Cultural Experience',
  organization: 'Tourism Authority of Thailand'
}, {
  title: 'Chef of the Year',
  organization: 'International Culinary Institute'
}];
export function Awards() {
  return <section className="bg-[#faf8f5] py-24 md:py-32 px-6" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-25">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-26">
            Recognition
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-27">
            Awards & Accolades
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-28" />
          <p className="text-[#86868b] text-[18px] max-w-2xl mx-auto font-light" data-id="element-29">
            Honored for excellence in culinary innovation and service
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-30">
          {awards.map((award, index) => <motion.div key={award.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white p-10 text-center border border-[#f0ebe3] hover:border-[#c9a961] transition-all duration-500 hover:shadow-lg group" data-id="element-31">
              <div className="w-16 h-16 rounded-full bg-[#faf8f5] flex items-center justify-center mx-auto mb-6 group-hover:bg-[#c9a961] transition-colors duration-500" data-id="element-32">
                <TrophyIcon className="w-8 h-8 text-[#c9a961] group-hover:text-white transition-colors duration-500" data-id="element-33" />
              </div>
              <h3 className="font-display text-[#1d1d1f] font-medium text-[20px] mb-3 leading-tight" data-id="element-34">
                {award.title}
              </h3>
              <p className="text-[#86868b] text-[12px] uppercase tracking-wide" data-id="element-35">
                {award.organization}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}